import {AfterViewInit, Component, OnInit, ViewChild} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {LensSectionMode, LensSide} from "src/app/model/configuration/configuration";
import {NewOrderFinalLensComponent} from "../new-order-final-lens/new-order-final-lens.component";
import {NewOrderProposalComponent} from "../new-order-proposal/new-order-proposal.component";
import {NewOrderStoreService} from "../new-order-store-service.service";
import {NewOrderTrialLensWithOverrefractionComponent} from "../new-order-trial-lens-with-overrefarction/new-order-trial-lens-with-overrefraction.component";
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'app-new-order',
  templateUrl: './new-order.component.html',
  styleUrls: ['./new-order.component.scss']
})
export class NewOrderComponent implements OnInit, AfterViewInit {
  @ViewChild('proposal') proposal: NewOrderProposalComponent;
  @ViewChild('trialLens') trialLens: NewOrderTrialLensWithOverrefractionComponent;
  @ViewChild('finalLens') finalLens: NewOrderFinalLensComponent;

  panelProposalOpenState = false;
  panelTrialLensOpenState = false;
  panelFinalLensOpenState = false;
  panelCareOpenState = false;
  panelAccessoriesOpenState = false;
  panelConfirmOpenState = true;

  private fragment: string;

  constructor(private newOrderStoreService: NewOrderStoreService, private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.activatedRoute.fragment.subscribe(fragment => { this.fragment = fragment; });

    let openPanel = this.newOrderStoreService.getLensSectionMode();
    if (openPanel === LensSectionMode.HECHT_PROPOSAL) {
      this.panelProposalOpenState = true;
    } else if (openPanel === LensSectionMode.TRIAL_LENS || openPanel === LensSectionMode.TRIAL_LENS_COPY) {
      this.panelTrialLensOpenState = true;
    } else if (openPanel === LensSectionMode.FINAL_LENS || openPanel === LensSectionMode.FINAL_LENS_COPY) {
      this.panelFinalLensOpenState = true;
    } else if (openPanel === LensSectionMode.CARE) {
      this.panelCareOpenState = true;
    } else if (openPanel === LensSectionMode.ACCESSORIES) {
      this.panelAccessoriesOpenState = true;
    } else if (openPanel === LensSectionMode.ORDER_CONFIRM) {
      this.panelConfirmOpenState = true;
    }

    this.newOrderStoreService.lensSectionMode$.subscribe(value => {
      if (value === LensSectionMode.HECHT_PROPOSAL) {
        this.panelProposalOpenState = true;
      } else if (value === LensSectionMode.TRIAL_LENS || value === LensSectionMode.TRIAL_LENS_COPY) {
        this.panelTrialLensOpenState = true;
      } else if (value === LensSectionMode.FINAL_LENS || value === LensSectionMode.FINAL_LENS_COPY) {
        this.panelFinalLensOpenState = true;
      } else if (value === LensSectionMode.CARE) {
        this.panelCareOpenState = true;
      } else if (value === LensSectionMode.ACCESSORIES) {
        this.panelAccessoriesOpenState = true;
      } else if (value === LensSectionMode.ORDER_CONFIRM) {
        this.panelConfirmOpenState = true;
      }
    });
  }

  ngAfterViewInit(): void {
    if (this.fragment != undefined) {
      try {
        document.getElementById(this.fragment).scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest"
        });
      } catch (e) {
      }
    }
  }

  copyProposal(side: LensSide) {
    if (side === LensSide.RIGHT) {
      Object.keys(this.proposal.spectacularRefractionRight.form.controls).forEach(key => {
        if (this.proposal.spectacularRefractionRight.form.controls[key].dirty) {
          this.proposal.spectacularRefractionLeft.form.controls[key].markAsTouched();
        }

        this.proposal.spectacularRefractionLeft.form.patchValue({
          [key]: this.proposal.spectacularRefractionRight.form.controls[key].value
        });
      });

      Object.keys(this.proposal.centralRadiusRight.form.controls).forEach(key => {
        if (this.proposal.centralRadiusRight.form.controls[key].dirty) {
          this.proposal.centralRadiusLeft.form.controls[key].markAsTouched();
        }

        this.proposal.centralRadiusLeft.form.patchValue({
          [key]: this.proposal.centralRadiusRight.form.controls[key].value
        });
      });

      this.proposal.centralRadiusLeft.previousEccentricityDialogResult = this.proposal.centralRadiusRight.previousEccentricityDialogResult;

    } else if (side === LensSide.LEFT) {
      Object.keys(this.proposal.spectacularRefractionLeft.form.controls).forEach(key => {
        if (this.proposal.spectacularRefractionLeft.form.controls[key].dirty) {
          this.proposal.spectacularRefractionRight.form.controls[key].markAsTouched();
        }

        this.proposal.spectacularRefractionRight.form.patchValue({
          [key]: this.proposal.spectacularRefractionLeft.form.controls[key].value
        });
      });

      Object.keys(this.proposal.centralRadiusLeft.form.controls).forEach(key => {
        if (this.proposal.centralRadiusLeft.form.controls[key].dirty) {
          this.proposal.centralRadiusRight.form.controls[key].markAsTouched();
        }

        this.proposal.centralRadiusRight.form.patchValue({
          [key]: this.proposal.centralRadiusLeft.form.controls[key || ''].value
        });
      });

      this.proposal.centralRadiusRight.previousEccentricityDialogResult = this.proposal.centralRadiusLeft.previousEccentricityDialogResult;
    }
  }

  copyTrialLens(side: LensSide) {
    if (side === LensSide.RIGHT) {
      Object.keys(this.trialLens.trialLensRight.form.controls).forEach(key => {
        if (this.trialLens.trialLensRight.form.controls[key].dirty) {
          this.trialLens.trialLensLeft.form.controls[key].markAsTouched();
        }

        this.trialLens.trialLensLeft.form.patchValue({
          [key]: this.trialLens.trialLensRight.form.controls[key].value
        });
      });

      this.trialLens.trialLensLeft.selectedBackSide = this.trialLens.trialLensRight.selectedBackSide;
      this.trialLens.trialLensLeft.selectBackSide();

      Object.keys(this.trialLens.overRefractionRight.form.controls).forEach(key => {
        if (this.trialLens.overRefractionRight.form.controls[key].dirty) {
          this.trialLens.overRefractionLeft.form.controls[key].markAsTouched();
        }

        this.trialLens.overRefractionLeft.form.patchValue({
          [key]: this.trialLens.overRefractionRight.form.controls[key].value
        });
      });

      Object.keys(this.trialLens.newParameterRight.form.controls).forEach(key => {
        if (this.trialLens.newParameterRight.form.controls[key].dirty) {
          this.trialLens.newParameterLeft.form.controls[key].markAsTouched();
        }

        this.trialLens.newParameterLeft.form.patchValue({
          [key]: this.trialLens.newParameterRight.form.controls[key].value
        });
      });
    } else if (side === LensSide.LEFT) {
      Object.keys(this.trialLens.trialLensLeft.form.controls).forEach(key => {
        if (this.trialLens.trialLensLeft.form.controls[key].dirty) {
          this.trialLens.trialLensRight.form.controls[key].markAsTouched();
        }

        this.trialLens.trialLensRight.form.patchValue({
          [key]: this.trialLens.trialLensLeft.form.controls[key].value
        });
      });

      this.trialLens.trialLensRight.selectedBackSide = this.trialLens.trialLensLeft.selectedBackSide;
      this.trialLens.trialLensRight.selectBackSide();

      Object.keys(this.trialLens.overRefractionLeft.form.controls).forEach(key => {
        if (this.trialLens.overRefractionLeft.form.controls[key].dirty) {
          this.trialLens.overRefractionRight.form.controls[key].markAsTouched();
        }

        this.trialLens.overRefractionRight.form.patchValue({
          [key]: this.trialLens.overRefractionLeft.form.controls[key].value
        });
      });

      Object.keys(this.trialLens.newParameterLeft.form.controls).forEach(key => {
        if (this.trialLens.newParameterLeft.form.controls[key].dirty) {
          this.trialLens.newParameterRight.form.controls[key].markAsTouched();
        }

        this.trialLens.newParameterRight.form.patchValue({
          [key]: this.trialLens.newParameterLeft.form.controls[key].value
        });
      });
    }
  }

  copyFinalLens(side: LensSide) {
    if (side === LensSide.RIGHT) {
      Object.keys(this.finalLens.finalLensRight.form.controls).forEach(key => {
        if (this.finalLens.finalLensRight.form.controls[key].dirty) {
          this.finalLens.finalLensLeft.form.controls[key].markAsTouched();
        }

        this.finalLens.finalLensLeft.form.patchValue({
          [key]: this.finalLens.finalLensRight.form.controls[key].value
        });
      });

      this.finalLens.finalLensLeft.showReturn = this.finalLens.finalLensRight.showReturn;
      if (this.finalLens.finalLensLeft.showReturn) {
        this.finalLens.finalLensLeft.isReturn = this.finalLens.finalLensRight.isReturn;
      }

      this.finalLens.finalLensLeft.showEase = this.finalLens.finalLensRight.showEase;
      if (this.finalLens.finalLensRight.showEase) {
        this.finalLens.finalLensLeft.easeDouble = this.finalLens.finalLensRight.easeDouble;
      }

      if (Object.keys(this.finalLens.finalLensRight.features).length !== 0) {
        this.finalLens.finalLensLeft.features = this.finalLens.finalLensRight.features;
        this.finalLens.finalLensLeft.isIndividual = this.finalLens.finalLensRight.isIndividual;
        if (this.finalLens.finalLensLeft.isIndividual) {
          this.finalLens.finalLensLeft.initLensDetailsForm(this.finalLens.finalLensLeft.features.individual);
        } else {
          this.finalLens.finalLensLeft.initLensDetailsForm(this.finalLens.finalLensLeft.features.default);
        }
      }

      Object.keys(this.finalLens.finalLensRight.lensDetailsForm.controls).forEach(key => {
        if (this.finalLens.finalLensRight.lensDetailsForm.controls[key].dirty) {
          this.finalLens.finalLensLeft.lensDetailsForm.controls[key].markAsTouched();
        }

        this.finalLens.finalLensLeft.lensDetailsForm.patchValue({
          [key]: this.finalLens.finalLensRight.lensDetailsForm.controls[key].value
        });
      });

      // set primary filters for copied side
      this.finalLens.finalLensLeft.isHard = this.finalLens.finalLensRight.isHard;
      this.finalLens.finalLensLeft.backSideId = this.finalLens.finalLensRight.backSideId;
      this.finalLens.finalLensLeft.filterPrimaryLists();

      this.newOrderStoreService.editFinalLensLeft = this.newOrderStoreService.editFinalLensRight;
      this.finalLens.finalLensLeft.indexEditFinalLens = this.finalLens.finalLensRight.indexEditFinalLens;
      this.finalLens.finalLensLeft.isEditFinalLens = this.finalLens.finalLensRight.isEditFinalLens;
      this.finalLens.finalLensLeft.defaultColor = this.finalLens.finalLensRight.defaultColor;
      this.finalLens.finalLensLeft.desireDate = this.finalLens.finalLensRight.desireDate;

    } else if (side === LensSide.LEFT) {
      Object.keys(this.finalLens.finalLensLeft.form.controls).forEach(key => {
        if (this.finalLens.finalLensLeft.form.controls[key].dirty) {
          this.finalLens.finalLensRight.form.controls[key].markAsTouched();
        }

        this.finalLens.finalLensRight.form.patchValue({
          [key]: this.finalLens.finalLensLeft.form.controls[key].value
        });
      });

      this.finalLens.finalLensRight.showReturn = this.finalLens.finalLensLeft.showReturn;
      if (this.finalLens.finalLensRight.showReturn) {
        this.finalLens.finalLensRight.isReturn = this.finalLens.finalLensLeft.isReturn;
      }

      this.finalLens.finalLensRight.showEase = this.finalLens.finalLensLeft.showEase;
      if (this.finalLens.finalLensLeft.showEase) {
        this.finalLens.finalLensRight.easeDouble = this.finalLens.finalLensLeft.easeDouble;
      }

      if (Object.keys(this.finalLens.finalLensLeft.features).length !== 0) {
        this.finalLens.finalLensRight.features = this.finalLens.finalLensLeft.features;
        this.finalLens.finalLensRight.isIndividual = this.finalLens.finalLensLeft.isIndividual;
        if (this.finalLens.finalLensRight.isIndividual) {
          this.finalLens.finalLensRight.initLensDetailsForm(this.finalLens.finalLensRight.features.individual);
        } else {
          this.finalLens.finalLensRight.initLensDetailsForm(this.finalLens.finalLensRight.features.default);
        }
      }

      Object.keys(this.finalLens.finalLensLeft.lensDetailsForm.controls).forEach(key => {
        if (this.finalLens.finalLensLeft.lensDetailsForm.controls[key].dirty) {
          this.finalLens.finalLensRight.lensDetailsForm.controls[key].markAsTouched();
        }

        this.finalLens.finalLensRight.lensDetailsForm.patchValue({
          [key]: this.finalLens.finalLensLeft.lensDetailsForm.controls[key].value
        });
      });

      // set primary filters for copied side
      this.finalLens.finalLensRight.isHard = this.finalLens.finalLensLeft.isHard;
      this.finalLens.finalLensRight.backSideId = this.finalLens.finalLensLeft.backSideId;
      this.finalLens.finalLensRight.filterPrimaryLists();

      this.newOrderStoreService.editFinalLensRight = this.newOrderStoreService.editFinalLensLeft;
      this.finalLens.finalLensRight.indexEditFinalLens = this.finalLens.finalLensLeft.indexEditFinalLens;
      this.finalLens.finalLensRight.isEditFinalLens = this.finalLens.finalLensLeft.isEditFinalLens;
      this.finalLens.finalLensRight.defaultColor = this.finalLens.finalLensLeft.defaultColor;
      this.finalLens.finalLensRight.desireDate = this.finalLens.finalLensLeft.desireDate;
    }
  }

  rotateProposal(isDual: boolean) {
    if (isDual) {
      // clone left proposal related FormGroups
      let spectacularRefraction = <FormGroup>{...this.proposal.spectacularRefractionLeft.form};
      let centralRadius = <FormGroup>{...this.proposal.centralRadiusLeft.form};
      let previousEccentricityDialogResult = this.proposal.centralRadiusLeft.previousEccentricityDialogResult;

      // R => L
      this.copyProposal(LensSide.RIGHT);

      // L => R
      Object.keys(spectacularRefraction.controls).forEach(key => {
        if (spectacularRefraction.controls[key].dirty) {
          this.proposal.spectacularRefractionRight.form.controls[key].markAsTouched();
        }
        this.proposal.spectacularRefractionRight.form.patchValue({
          [key]: spectacularRefraction.value[key]
        });
      });

      Object.keys(centralRadius.controls).forEach(key => {
        if (centralRadius.controls[key].dirty) {
          this.proposal.centralRadiusRight.form.controls[key].markAsTouched();
        }
        this.proposal.centralRadiusRight.form.patchValue({
          [key]: centralRadius.value[key]
        });
      });

      this.proposal.centralRadiusRight.previousEccentricityDialogResult = previousEccentricityDialogResult;
    }
  }

  rotateTrialLens(isDual: boolean) {
    if (isDual) {
      // clone trialLeftLens related FormGroups
      let storedForm = <FormGroup>{...this.trialLens.trialLensLeft.form};
      let selectedBackSide = this.trialLens.trialLensLeft.selectedBackSide;
      let overRefraction = <FormGroup>{...this.trialLens.overRefractionLeft.form};
      let newParameter = <FormGroup>{...this.trialLens.newParameterLeft.form};

      // R => L
      this.copyTrialLens(LensSide.RIGHT);

      // L => R
      Object.keys(storedForm.controls).forEach(key => {
        if (storedForm.controls[key].dirty) {
          this.trialLens.trialLensRight.form.controls[key].markAsTouched();
        }
        this.trialLens.trialLensRight.form.patchValue({
          [key]: storedForm.value[key]
        });
      });

      this.trialLens.trialLensRight.selectedBackSide = selectedBackSide;
      this.trialLens.trialLensRight.selectBackSide();

      Object.keys(overRefraction.controls).forEach(key => {
        if (overRefraction.controls[key].dirty) {
          this.trialLens.overRefractionRight.form.controls[key].markAsTouched();
        }
        this.trialLens.overRefractionRight.form.patchValue({
          [key]: overRefraction.value[key]
        });
      });

      Object.keys(newParameter.controls).forEach(key => {
        if (newParameter.controls[key].dirty) {
          this.trialLens.newParameterRight.form.controls[key].markAsTouched();
        }
        this.trialLens.newParameterRight.form.patchValue({
          [key]: newParameter.value[key]
        });
      });

    }
  }

  rotateFinalLens(isDual: boolean) {
    if (isDual) {
      const originalLeft = this.finalLens.finalLensLeft;

      // clone finalLeftLens FormGroups and options
      let storedForm = <FormGroup>{...originalLeft.form};
      let showReturn = originalLeft.showReturn;
      let isReturn = originalLeft.isReturn;
      let features = originalLeft.features;
      let lensDetails = <FormGroup>{...originalLeft.lensDetailsForm};
      let indexEditFinalLens = originalLeft.indexEditFinalLens;
      let isEditFinalLens = originalLeft.isEditFinalLens;
      let defaultColor = originalLeft.defaultColor;

      // R => L
      this.copyFinalLens(LensSide.RIGHT);

      // L => R
      Object.keys(storedForm.controls).forEach(key => {
        if (storedForm.controls[key].dirty) {
          this.finalLens.finalLensRight.form.controls[key].markAsTouched();
        }
        this.finalLens.finalLensRight.form.patchValue({
          [key]: storedForm.value[key]
        });
      });

      this.finalLens.finalLensRight.showReturn = showReturn;
      if (showReturn) {
        this.finalLens.finalLensRight.isReturn = isReturn;
      }

      if (Object.keys(features).length !== 0) {
        this.finalLens.finalLensRight.features = features;
        this.finalLens.finalLensRight.isIndividual = false;
        if (this.finalLens.finalLensRight.isIndividual) {
          this.finalLens.finalLensRight.initLensDetailsForm(this.finalLens.finalLensRight.features.individual);
        } else {
          this.finalLens.finalLensRight.initLensDetailsForm(this.finalLens.finalLensRight.features.default);
        }
      }

      Object.keys(lensDetails.controls).forEach(key => {
        if (lensDetails.controls[key].dirty) {
          this.finalLens.finalLensRight.lensDetailsForm.controls[key].markAsTouched();
        }
        this.finalLens.finalLensRight.lensDetailsForm.patchValue({
          [key]: lensDetails.controls[key].value
        });
      });

      this.newOrderStoreService.editFinalLensRight = this.newOrderStoreService.editFinalLensLeft;
      this.finalLens.finalLensRight.indexEditFinalLens = indexEditFinalLens;
      this.finalLens.finalLensRight.isEditFinalLens = isEditFinalLens;
      this.finalLens.finalLensRight.defaultColor = defaultColor;
    }
  }

  switch(side: LensSide) {
    this.copyProposal(side);
    this.copyTrialLens(side);
    this.copyFinalLens(side);
  }
}
